import ClosuresHistoryFilter from "../features/closures/components/closures-history-filter";

export default function ClosuresView() {
  return (
    <div>
      <ClosuresHistoryFilter />
    </div>
  )
}